import React, { Fragment, useEffect, useState } from "react";
import { Marker, CircleMarker, useMap } from "react-leaflet";
import { airspaceType } from "../../constants/airspaceData";
import { getNavaidIcon } from "../../utils/navaidIcon";
import InfoPopup from "./InfoPopup";

export default function RenderNavidsAirspace({
  navidAirspaceGeometry,
  handleViewMore,
}) {
  const map = useMap();
  const [isShowIcon, setShowIcon] = useState(false);

  useEffect(() => {
    if (navidAirspaceGeometry?.length <= 15) {
      setShowIcon(true);
    } else {
      setShowIcon(false);
    }
  }, [navidAirspaceGeometry]);

  map.on("zoomend", function (e) {
    if (navidAirspaceGeometry?.length <= 15) {
      return;
    }

    const zoomLevel = e.target.getZoom();
    if (zoomLevel >= 7) {
      setShowIcon(true);
    } else {
      setShowIcon(false);
    }
  });

  const handlePolygonOver = (e) => {
    e.target.openPopup();
  };

  const handlePolygonClick = (info) => {
    handleViewMore(info, airspaceType.navaids);
  };

  return (
    <Fragment>
      {!isShowIcon &&
        navidAirspaceGeometry.map((data, i) => {
          return (
            <CircleMarker
              key={i}
              pane="tooltipPane"
              center={{
                lat: data.dd_coordinates[0],
                lng: data.dd_coordinates[1],
              }}
              pathOptions={{
                color: "#8b0000",
                fillOpacity: 0.5,
                weight: 1,
              }}
              radius={4}
              eventHandlers={{
                mouseover: (e) => handlePolygonOver(e),
                click: () => handlePolygonClick(data),
              }}
            >
              <InfoPopup info={data} />
            </CircleMarker>
          );
        })}
      {isShowIcon &&
        navidAirspaceGeometry.map((data, i) => {
          return (
            <Marker
              key={i}
              icon={getNavaidIcon(data.type)}
              position={{
                lat: data.dd_coordinates[0],
                lng: data.dd_coordinates[1],
              }}
              eventHandlers={{
                mouseover: (e) => handlePolygonOver(e),
                click: () => handlePolygonClick(data),
              }}
            >
              <InfoPopup info={data} />
            </Marker>
          );
        })}
    </Fragment>
  );
}
